import { render, staticRenderFns } from "./RowBlockPaymentInsuranceByLegalEntity.vue?vue&type=template&id=61dcea80&"
import script from "./RowBlockPaymentInsuranceByLegalEntity.vue?vue&type=script&lang=js&"
export * from "./RowBlockPaymentInsuranceByLegalEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports